import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";
import { Box } from "@material-ui/core";
import ToolBar from "../../Toolbar";
import DeploymentOptions from "./DeploymentOptions";

class Admin extends Component {
  render() {
    return (
      <Box>
        <ToolBar>
          <div />
        </ToolBar>
        <Box p={4}>
          <Switch>
            <Route exact path="/admin" component={DeploymentOptions} />

            {/* <Route exact path="/edit/:schemaId/:entryId" component={ContentEntry} /> */}
          </Switch>
        </Box>
      </Box>
    );
  }
}

export default connect(state => ({}), {})(Admin);
